import AdminBackLink from '../../components/atoms/AdminBackLink';
import { STATUS_LABELS } from '../../constants/status';

type FailedPageProps = {
  status: string;
  adminUserName: string | null;
};

export default function FailedPage({ status, adminUserName }: FailedPageProps) {
  return (
    <div className="flex flex-col gap-4">
      <AdminBackLink to="/admin" search={{ tab: 'import_requests' }} />
      <div className="flex flex-col gap-3 rounded border border-solid border-border bg-white p-6">
        <dl className="grid grid-cols-[auto_1fr] gap-4 text-sm">
          <dt className="text-sub">ステータス</dt>
          <dd className="text-main">{STATUS_LABELS[status] ?? status}</dd>
          <dt className="text-sub">担当者</dt>
          <dd className="text-main">{adminUserName ?? '—'}</dd>
        </dl>
      </div>
    </div>
  );
}
